import { useGetPurchaseHistoryQuery } from '@/queries/useGetPurchaseHistoryQuery';

export const usePurchaseHistory = () => {
  const { data: purchaseData, isLoading } = useGetPurchaseHistoryQuery();

  if (isLoading) {
    return { purchaseData: [], isLoading };
  }

  return { purchaseData };
};
